import { render } from "./BlogCategory.vue?vue&type=template&id=7e25232d&scoped=true"
import script from "../js/blog-category.js?vue&type=script&lang=js"
export * from "../js/blog-category.js?vue&type=script&lang=js"

import "./BlogCategory.vue?vue&type=style&index=0&id=7e25232d&scoped=true&lang=css"

import exportComponent from "/Users/mdmahamudurzamanbhuyan/Sites/localhost/disposhop_jars/dispo_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e25232d"]])

export default __exports__